import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from '../method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GeneralWPService extends MethodsService {
  constructor(_HandlerService: HandlerService, http: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  getDataMenuSuperior() {
    return this.get('apimj/menu_superior_components?identifier=all');
  }
  getByIdentifierOptions(identifier = 'all') {
    return this.get('apimj/general_options?identifier=' + identifier);
  }
  getGeneralOptions() {
    return this.get('apimj/general_options?identifier=general');
  }
  /**
   * @description Obtener toda la información del widget
   * @returns Regresa JSON de widget
   */
  getOrdenamiento(ruta) {
    return this.get('apimj/mainfront/components/' + ruta + '?identifier=ordenamiento');
  }
}
